import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=5ce5cb53&"
import script from "./AdminCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports